import Vue from 'vue'
import VueScrollactive from 'vue-scrollactive'
import VueMarkdown from 'vue-markdown'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import VueGtag from 'vue-gtag'

Vue.use(VueScrollactive)
Vue.use(VueGtag, {
  config: {id: 'G-BSNCGMV709'}
}, router);
Vue.use(VueMarkdown);
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
